import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { LayoutList, ShieldCheck } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchCampaigns, ADS_STR as S, type CampaignRow } from './adsApi'

/**
 * A20.04 — Кампании (campaigns list). Dormant until `/admin/ads/campaigns`
 * ships. Placeholder permission USERS_VIEW (REGISTER.md: `ads.campaign.view`).
 */
export function CampaignsScreen() {
  const columns = useMemo<AdminColumn<CampaignRow>[]>(
    () => [
      { key: 'title', header: S.title, type: 'text' },
      { key: 'advertiser', header: S.advertiser, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'budget', header: S.budget, type: 'number' },
      { key: 'spent', header: S.spent, type: 'number' },
      { key: 'cpm', header: S.cpm, type: 'number' },
      { key: 'impressions', header: S.impressions, type: 'number' },
      { key: 'clicks', header: S.clicks, type: 'number' },
    ],
    [],
  )
  const fetcher = useCallback(fetchCampaigns, [])
  return (
    <>
      <PageHeader
        title={S.campaigns}
        screenId="A20.04"
        actions={
          <Link
            to="/ads/creatives"
            className="inline-flex items-center gap-1.5 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:border-border-strong hover:text-primary"
          >
            <ShieldCheck size={13} />
            {S.creatives}
          </Link>
        }
      />
      <DataTable<CampaignRow>
        screenId="A20.04"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <LayoutList size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
